module.exports = __webpack_public_path__ + "img/bg.c0814a3c.png";